<template>
  <div class="testing">
    <app-container>
      <h1 class="testing__title">{{ test.base.name }}</h1>
      <div
        class="page-grid"
        style="grid-template-columns: 3fr 1fr;"
      >
        <div class="page-grid__content">
          <testing-form class="testing__form"/>
        </div>
        <img
          class="page-grid__image"
          src="@/assets/images/testing-bg.svg"
        >
      </div>
    </app-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TestingForm from '../components/Forms/TestingForm';
import AppContainer from '../components/Base/AppContainer';

export default {
  name: 'Testing',
  components: {
    TestingForm,
    AppContainer,
  },
  computed: {
    ...mapState('tests', ['test']),
  },
};
</script>

<style lang="scss" scoped>
  .testing {
    padding: 40px 0;
  }

  @media screen and (max-width: $window-md) {
    .testing {
      &__title {
        font-size: 20px;
      }
    }
  }
</style>
